import {Inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'localizedQuantity',
})
export class LocalizedQuantityPipe implements PipeTransform {
  constructor(@Inject(TranslateService) private translateService: TranslateService) {
  }

  transform(value: number, type: 'DAYS' | 'HOURS' | 'day' | 'hour'): unknown {
    let lang = this.translateService.currentLang;
    if (lang.toLowerCase() === 'gb') {
      lang = 'en';
    }
    const finalType = type.toLowerCase() === 'days' ? 'day' : 'hour';
    if (0 === value) {
      return '0 ' + this.translateService.instant('global.common.' + finalType + (lang === 'en' ? 's' : ''));
    } else if (value > 0 && value <= 1) {
      return value + ' ' + this.translateService.instant('global.common.' + finalType);
    }
    return value + ' ' + this.translateService.instant('global.common.' + finalType + 's');
  }

}
